import { render, staticRenderFns } from "./mumsnetP3.vue?vue&type=template&id=20e6106b&scoped=true&"
import script from "./mumsnetP3.vue?vue&type=script&lang=js&"
export * from "./mumsnetP3.vue?vue&type=script&lang=js&"
import style0 from "./mumsnetP3.vue?vue&type=style&index=0&id=20e6106b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e6106b",
  null
  
)

export default component.exports